module.exports = __webpack_public_path__ + "static/media/Arrow-Disabled.611f4760.svg";